import { useParams } from 'react-router-dom';

import { useAppLayoutContext } from '@/components/app-layout/context';

import BuilderForm from '../components/BuilderForm';
import { PostProvider, usePostStore } from '../store';

function PostBuilderForm() {
  const { id } = useParams()
  const { setMenuCollapsed } = useAppLayoutContext()
  setMenuCollapsed(true)

  const { collection: { useLoad } } = usePostStore()

  useLoad(id)

  return <BuilderForm />
}

export default function PostBuilderFormLayout() {
  return <PostProvider>
    <PostBuilderForm />
  </PostProvider>
}
